import { Component, ComponentChildren } from 'preact'
import { z } from 'zod'
import { ModulesContext } from '../../utils/globals'
import classnames from 'classnames'

export interface WidgetContainerProps extends WidgetContainerConfigProps {
  widgetName: string
  alwaysAddPadding?: boolean
  children: ComponentChildren
}

export interface WidgetContainerConfigProps extends z.infer<typeof widgetContainerConfig> {
  title?: string
}

export const widgetContainerConfig = z.object({
  title: z.union([z.string(), z.undefined()]),
  subtitle: z.union([z.string(), z.undefined()]),
  backgroundColor: z.union([z.string(), z.undefined()]),
  backgroundColorDisplay: z.union([z.string(), z.undefined()])
})

export default class WidgetContainer extends Component<WidgetContainerProps> {
  render({ title, backgroundColor, backgroundColorDisplay, subtitle, widgetName, children }: WidgetContainerProps) {
    return (
      <ModulesContext.Consumer>
        {(modules) => {
          const isFeatureFlagEnabled = modules.includes('subtitleAndBackgroundToWidgets')
          const style = isFeatureFlagEnabled && backgroundColorDisplay === 'solid_color' ? { backgroundColor } : undefined

          return (
            <section
              className={classnames(widgetName, `qa-${widgetName}-container homepage-widget-wrapper `, {
                'widget-container-spacing': this.props.alwaysAddPadding || backgroundColorDisplay === 'solid_color'
              })} style={style}
            >
              <div className='sitewidth'>
                <div className='col'>
                  {title && <h3 className={`widget__heading ${widgetName}__heading`}>{title}</h3>}
                  {subtitle && isFeatureFlagEnabled && (
                    <h4 className={`widget__subheading ${widgetName}__subheading font-normal-weight`}>{subtitle}</h4>
                  )}
                  {children}
                </div>
              </div>
            </section>
          )
        }}
      </ModulesContext.Consumer>
    )
  }
}
